<button (click)="toggleNitification()" class="btn nav-item nav-link notification" type="button">
    <i id="noficationId" [ngClass]="hasNewNotification==true ? 'fas fa-bell notification-dot': 'fas fa-bell'"></i>
</button>


<div class="navbar-collapse-custom" [ngClass]="{'collapse-custom ': collapsed}">
    <ul [ngClass]="{'opendrawer': toggleNotificationbox}" class="mob-drop notification-drawer notification-drawer-wrapper"   [busy]="loading">
        <li>
            <h6 class="mt-2"> {{'Notification' | localize}}</h6>
        </li>
        <li *ngFor="let notif of notifications;let i=index" class="d-flex align-items-start justify-content-between">
            <div *ngIf="i != notifications.length-1">
                <a (click)="markRead(notif)">
                <span *ngIf="notif.read==false"><b>{{notif.message | localize}}</b></span>
                <span *ngIf="notif.read==true"> {{notif.message | localize }}</span> </a>
                <small class="text-muted text-nowrap pull-right">{{notif.creationTime | date}}</small>
            </div>
            <div *ngIf="i == notifications.length-1" #lastItem>
                <a (click)="markRead(notif)">
                    <span *ngIf="notif.read==false"><b>last-{{notif.message | localize}}</b></span>
                    <span *ngIf="notif.read==true"> {{notif.message | localize }}</span> </a>
                <small class="text-muted text-nowrap">{{notif.creationTime | date}}</small>
            </div>
        </li>
        <li *ngIf="!loading && !(notifications && notifications.length >0)" class="d-flex align-items-start justify-content-between">
            <div>
                <span> {{"NoItems" | localize }}</span> 
            </div>
        </li>
    </ul>
</div>